import { faLine } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ColorPalettes } from '../../../../../patient/src/features/reservation/constants/ColorPalettes';
import { ReactNode } from 'react';

type IconType = 'line' | 'custom';

export type IconProps = {
  icon: IconType;
  customIcon?: ReactNode;
};

/**
 * アイコンを取得する。
 * @param icon 取得したいアイコン
 * @param customIcon カスタムアイコン
 * @returns アイコン
 */
const getIcon = (icon: IconType, customIcon?: ReactNode) => {
  switch (icon) {
    case 'line':
      return <FontAwesomeIcon icon={faLine} color={ColorPalettes.LINE_MAIN} />;
    default:
      return customIcon;
  }
};

/**
 * アイコンコンポーネント
 * @param icon アイコン
 * @param customIcon カスタムアイコン
 * @returns アイコンコンポーネント
 */
export const Icon = ({ icon = 'custom', customIcon }: IconProps) => {
  return getIcon(icon, customIcon);
};
